export default "__VITE_ASSET__Bulomitg__"